var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { View } from 'react-native';
import EngagementCard from '../engagement-cards/EngagementCard';
import { getEngagementRowStyles } from './EngagementRowStyle';
import { getTestId } from '@airtel/air-design-system';
var EngagementRow = props => {
  var testID = props.testID,
    rowData = props.rowData,
    restProps = __rest(props, ["testID", "rowData"]);
  var engagementRowStyles = getEngagementRowStyles(props);
  return _jsx(View, Object.assign({
    style: engagementRowStyles.row
  }, {
    children: rowData === null || rowData === void 0 ? void 0 : rowData.map((item, index) => {
      return _jsx(View, Object.assign({
        style: [engagementRowStyles.cardWrapper]
      }, {
        children: _createElement(EngagementCard, Object.assign({}, item, restProps, {
          key: "engagement-row-data-" + index,
          id: index
        }, getTestId(testID, "engagement-row-data-" + index)))
      }));
    })
  }));
};
export default EngagementRow;